// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
    width: 100%;
  }
  
  img {
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-top: 5px;
  }
  /* Style the table header */
mat-header-cell {
    background-color: #008fc7; /* Primary color */
    color: rgb(0, 0, 0); /* Text color */
    font-weight: bold;
    justify-content: center;
    /* padding: 12px; */
    border-bottom: 2px solid #008fc7; /* Border color */
  }
  
  mat-cell {
    justify-content: center;
    padding: 10px;
  }
  
  /* Add a hover effect for table rows */
  mat-row:hover {
    background-color: #f1f1f1; /* Light gray hover effect */
  }
  
  /* Style the table itself */
  mat-table {
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin: 20px 0;
  }
  
  /* Add some spacing around the buttons */
  button {
    margin: 0 5px;
  }
  
  /* Ensure form fields take up the full width */
  mat-form-field {
    width: 100%;
  }
  .mat-paginator {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .top-space{
    justify-content: space-between;
  }
  .file-upload-container {
    display: inline-block;
    position: relative;
  }
  
  input[type="file"] {
    display: none; /* Hide default file input */
  }
  
  .custom-file-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    background-color: #1976d2; /* Customize button color */
    color: white;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;
  }
  
  .custom-file-upload:hover {
    background-color: #1565c0; /* Hover color */
  }
  
  .custom-file-upload mat-icon {
    margin-right: 5px;
    font-size: 18px;
  }
  
  img {
    border: 1px solid #ddd;
    padding: 2px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  /* Overlay */
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  /* Popup Content */
  .popup-content {
    position: relative;
    background: white;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }
  
  .popup-content img {
    max-width: 90vw;
    max-height: 80vh;
    border-radius: 8px;
  }
  
  /* Close Button */
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 24px;
    color: white;
    cursor: pointer;
  }


  
  .file-upload-container {
    margin-bottom: auto; /* Push the file upload container to the top */
  }

  


  .cell-content {
    display: flex;
    flex-direction: column; /* Stack elements vertically */
    justify-content: center; /* Center the input vertically */
    align-items: center; /* Align items horizontally at the center */
width: 100%;
    position: relative; /* Required for precise alignment */
  }
  

  
  .error {
    color: red;
    font-size: 12px;
    margin-top: 5px;
    margin-bottom:-3rem;
    align-self: flex-start; /* Align the error message to the left */
    position: absolute; /* Place the error message at the bottom */
    bottom: 5px;
    display: contents;
  }
  
.container {
  text-align: center;

  .inner-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      margin-top: 5%;

      .img {

          max-width: 300px;
          width: 300px; 
      }

      .title {
          font-size: 2rem;
          font-weight: bold;
          color: #000;
          margin-bottom: 1rem;
      }

      .description {
          font-size: 1rem;
          color: #000;
      }
  }
}



.no-templates {
  text-align: center;
  padding: 24px;
}

.no-templates-image {
  width: 100%;
  max-width: 300px;
  margin-bottom: 16px;
}

.no-templates-title {
  font-size: 1.5rem;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/app/views/components-templates/components-templates.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA,2BAA2B;AAC7B;IACI,yBAAyB,EAAE,kBAAkB;IAC7C,mBAAmB,EAAE,eAAe;IACpC,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC,EAAE,iBAAiB;EACrD;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA,2BAA2B;EAC3B;IACE,WAAW;IACX,yBAAyB;IACzB,wCAAwC;IACxC,cAAc;EAChB;;EAEA,wCAAwC;EACxC;IACE,aAAa;EACf;;EAEA,8CAA8C;EAC9C;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa,EAAE,4BAA4B;EAC7C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB,EAAE,2BAA2B;IACtD,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB,EAAE,gBAAgB;EAC7C;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,wCAAwC;EAC1C;;EAEA,YAAY;AACd;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA,kBAAkB;EAClB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;;;EAIA;IACE,mBAAmB,EAAE,8CAA8C;EACrE;;;;;EAKA;IACE,aAAa;IACb,sBAAsB,EAAE,8BAA8B;IACtD,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB,EAAE,2CAA2C;AACpE,WAAW;IACP,kBAAkB,EAAE,mCAAmC;EACzD;;;;EAIA;IACE,UAAU;IACV,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,sBAAsB,EAAE,wCAAwC;IAChE,kBAAkB,EAAE,0CAA0C;IAC9D,WAAW;IACX,iBAAiB;EACnB;;AAEF;EACE,kBAAkB;;EAElB;MACI,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;;MAEnB,cAAc;;MAEd;;UAEI,gBAAgB;UAChB,YAAY;MAChB;;MAEA;UACI,eAAe;UACf,iBAAiB;UACjB,WAAW;UACX,mBAAmB;MACvB;;MAEA;UACI,eAAe;UACf,WAAW;MACf;EACJ;AACF;;;;AAIA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["mat-form-field {\r\n    width: 100%;\r\n  }\r\n  \r\n  img {\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    margin-top: 5px;\r\n  }\r\n  /* Style the table header */\r\nmat-header-cell {\r\n    background-color: #008fc7; /* Primary color */\r\n    color: rgb(0, 0, 0); /* Text color */\r\n    font-weight: bold;\r\n    justify-content: center;\r\n    /* padding: 12px; */\r\n    border-bottom: 2px solid #008fc7; /* Border color */\r\n  }\r\n  \r\n  mat-cell {\r\n    justify-content: center;\r\n    padding: 10px;\r\n  }\r\n  \r\n  /* Add a hover effect for table rows */\r\n  mat-row:hover {\r\n    background-color: #f1f1f1; /* Light gray hover effect */\r\n  }\r\n  \r\n  /* Style the table itself */\r\n  mat-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    margin: 20px 0;\r\n  }\r\n  \r\n  /* Add some spacing around the buttons */\r\n  button {\r\n    margin: 0 5px;\r\n  }\r\n  \r\n  /* Ensure form fields take up the full width */\r\n  mat-form-field {\r\n    width: 100%;\r\n  }\r\n  .mat-paginator {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  .top-space{\r\n    justify-content: space-between;\r\n  }\r\n  .file-upload-container {\r\n    display: inline-block;\r\n    position: relative;\r\n  }\r\n  \r\n  input[type=\"file\"] {\r\n    display: none; /* Hide default file input */\r\n  }\r\n  \r\n  .custom-file-upload {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 5px 10px;\r\n    background-color: #1976d2; /* Customize button color */\r\n    color: white;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .custom-file-upload:hover {\r\n    background-color: #1565c0; /* Hover color */\r\n  }\r\n  \r\n  .custom-file-upload mat-icon {\r\n    margin-right: 5px;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  img {\r\n    border: 1px solid #ddd;\r\n    padding: 2px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  /* Overlay */\r\n.popup-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.8);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  /* Popup Content */\r\n  .popup-content {\r\n    position: relative;\r\n    background: white;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\r\n  }\r\n  \r\n  .popup-content img {\r\n    max-width: 90vw;\r\n    max-height: 80vh;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  /* Close Button */\r\n  .close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 24px;\r\n    color: white;\r\n    cursor: pointer;\r\n  }\r\n\r\n\r\n  \r\n  .file-upload-container {\r\n    margin-bottom: auto; /* Push the file upload container to the top */\r\n  }\r\n\r\n  \r\n\r\n\r\n  .cell-content {\r\n    display: flex;\r\n    flex-direction: column; /* Stack elements vertically */\r\n    justify-content: center; /* Center the input vertically */\r\n    align-items: center; /* Align items horizontally at the center */\r\nwidth: 100%;\r\n    position: relative; /* Required for precise alignment */\r\n  }\r\n  \r\n\r\n  \r\n  .error {\r\n    color: red;\r\n    font-size: 12px;\r\n    margin-top: 5px;\r\n    margin-bottom:-3rem;\r\n    align-self: flex-start; /* Align the error message to the left */\r\n    position: absolute; /* Place the error message at the bottom */\r\n    bottom: 5px;\r\n    display: contents;\r\n  }\r\n  \r\n.container {\r\n  text-align: center;\r\n\r\n  .inner-content {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      align-items: center;\r\n\r\n      margin-top: 5%;\r\n\r\n      .img {\r\n\r\n          max-width: 300px;\r\n          width: 300px; \r\n      }\r\n\r\n      .title {\r\n          font-size: 2rem;\r\n          font-weight: bold;\r\n          color: #000;\r\n          margin-bottom: 1rem;\r\n      }\r\n\r\n      .description {\r\n          font-size: 1rem;\r\n          color: #000;\r\n      }\r\n  }\r\n}\r\n\r\n\r\n\r\n.no-templates {\r\n  text-align: center;\r\n  padding: 24px;\r\n}\r\n\r\n.no-templates-image {\r\n  width: 100%;\r\n  max-width: 300px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.no-templates-title {\r\n  font-size: 1.5rem;\r\n  color: #555;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
